import * as React from 'react'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportEmployeeSelector from '../../ExportFields/ExportEmployeeSelector'
import ReferenceDate from '../../ExportFields/ReferenceDate'

interface Props {
  form: ReportsForm
}

const CompanyTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ReferenceDate form={form} />
    </>
  )
}

export default CompanyTimeoffFields
